import type { OfficeLayoutV1 } from "spatial-contracts";
import { cozyHqLayout } from "./maps/cozy-hq";
import { collaborativeLobbyLayout } from "./maps/collaborative-lobby";

export const MAP_REGISTRY: Record<string, OfficeLayoutV1> = {
  "cozy-hq": cozyHqLayout,
  "collaborative-lobby": collaborativeLobbyLayout,
};

/**
 * Returns a registered office map layout based on the workspace slug.
 * Serves as a dynamic Map Orchestrator.
 */
export function getMapLayout(workspaceSlug?: string): OfficeLayoutV1 {
  if (!workspaceSlug) return cozyHqLayout;

  const normalized = workspaceSlug.toLowerCase();
  
  // Custom workspace matching rules
  if (normalized.includes("lobby") || normalized.includes("lounge") || normalized.includes("sandbox")) {
    return collaborativeLobbyLayout;
  }
  
  return cozyHqLayout;
}
